import { useEffect } from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import { convertToDateObject, convertToISOString } from '../../utils/helpers';

interface DatePickerTypes {
    value?: string | Date;
    name?: string;
    setValue?: (name: string) => void;
    disabled?: boolean;
    defaultNull?: boolean;
    label?: string;
}

export default function BasicDatePicker({ value, setValue, disabled, defaultNull, label }: DatePickerTypes) {
    const formattedValue = defaultNull ? null : dayjs(value ? convertToDateObject(value) : null);
    const CALENDER_COLOR = '#0A7AFF';

    useEffect(() => {
        if (!value && !defaultNull) {
            const date = convertToISOString(new Date());
            setValue && setValue(date);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- MOUNT ONLY by product decision (Option A). Initial seed when empty and defaultNull is false. Do NOT add `value`: clearing would re-seed "now" and make empty impossible. Do NOT add `setValue`/`defaultNull` either — those would also re-seed after mount. See docs/react-hooks-cleanup/07-phase7-date-time-picker-decision.md
    }, []);

    const handleDateChange = (date: any) => {
        setValue && setValue(date);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
                <DatePicker
                    slots={{
                        openPickerIcon: (props) => <CalendarMonthRoundedIcon {...props} sx={{ color: CALENDER_COLOR }} />,
                    }}
                    value={formattedValue}
                    onChange={handleDateChange}
                    label={label || 'Date'}
                    disabled={disabled}
                />
            </DemoContainer>
        </LocalizationProvider>
    );
}
